<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          Paikeについて
        </h1>
        <p class="mb-4 indent">Paikeは、「好き」を共通言語に、</p>
        <ul class="mb-4">
          <li>英語等の外国語が苦手な人でも、気軽に国際交流を楽しんで欲しい</li>
          <li>旅行者に表面的な観光ではなく地元の人々ともっと触れ合って欲しい</li>
        </ul>
        <p class="mb-4">という想いから、シリコンバレーの地で、生まれました。この想いは、Founder（創業者）自身の２つの原体験から来ています。</p>

        <p class="font-weight-bold textBlack--text mb-0">
          1. 英語もろくにしゃべれないままでのアメリカ生活
        </p>
        <p class="mb-0 indent">
          Founderが英語もろくにしゃべれないまま、カリフォルニアのベイエリア（シリコンバレー／サンフランシスコ一帯）で生活を始めた際、「好き」なものが共通である人とは、英語に関係なく盛り上がる、ということを身を以て体感しました。
        </p>
        <p class="mb-0 indent">
          例えば、マウテンバイクでバークレーのTilden Regional Parkを走っていた際に出会ったバイク好きのTony、近所のBreweryで出会ったビール好きのDanielなどとは、つたない英語であっても、話が尽きることはありませんでした。
        </p>
        <p class="mb-4 indent">
          「好き」を一緒に楽しむのであれば、「好き」が共通言語として働き、難しい英語は、必要ないのです。
        </p>

        <p class="font-weight-bold textBlack--text mb-0">
          2. ガイドブックにはない体験の楽しさ
        </p>
        <p class="indent mb-0">
          Founderが、大学生時代、台湾、中国、チュニジア、ギリシャ、イタリアなどを一人で世界各地を自転車やバックパックで旅した際に、何よりも楽しかったのは、ガイドブックに載っていない自分だけのお気に入りの場所を見つけること、地元の人たちと交流すること、でした。
        </p>
        <p class="indent mb-4">
          周りに砂漠しかなかったチュニジア南部の名もなき町で出会った若者、チベットのラサでカラオケに連れて行ってくれた警察官、自転車で丘を登りきった後に広がっていたイタリア南部の田園地帯の雄大な景色、何か懐かしかったシチリア島の農村、これらの人々、景色は、ガイドブックには決して載っていません。名前も具体的な場所も、今では覚えていません。しかし、その人々との触れ合い、かけがえのない経験は、今も私の宝物です。
        </p>
        <p class="indent mb-0">
          2019年5月5日、Founderがシリコンバレー近郊のPleasantonのRegional Parkをジョギングしていたところ、この２つの原体験とともに、サービスのアイデアが突然、頭をよぎりました。
        </p>
        <p class="indent mb-0">
          世界の旅行者人口が爆発的に増える一方で、旅行者の大半は、ガイドブックに載っている観光地を見て回り、ホテルに泊まるだけで、地元との人との交流の機会を持つことなく帰国してしまいます。また、ガイドを雇ったとしても、お金を支払うため、どうしても、ビジネス的な雰囲気になってしまい、本当の意味での交流が難しいのが実情です。
        </p>
        <p class="indent mb-0">
          非常にもったいないことです。そこで、Paikeは、語学の壁がある旅行者とローカルを、「好き」を共通言語につなげ、一緒に、自分の「好き」を旅先で楽しむことができるプラットフォームを、無料で提供します。
        </p>
        <p class="indent mb-0">
          語学の壁は、大きな壁です。Founder自身、アメリカの地で、強く実感しています。しかし、「好き」が同じであれば、大丈夫です。
        </p>
        <p class="indent mb-4">
          みなさん、語学の壁を気にせず、一歩踏み出して、友達と遊ぶような感覚で、言語に関係なく、Paike outしましょう。
        </p>
        <p class="caption">
          ※「旅行者」とは、海外旅行に行く旅行者を指します。<br>
          　「ローカル」とは、旅行者の旅先で日々生活している地元の人を指します。<br>
          　「Paike」は、この旅行者とローカルを「好き」で結ぶグローバルマッチングプラットフォームです。<br>
          　「Paike out」とは、旅行者とローカルが、Paikeで出会い、一緒に好きを楽しむことを指します。
        </p>
        <p class="caption mb-4">
          ※　現在は、β（ベータ）版のため、機能や地域を限定的に運用しています。順次、利用可能地域も世界に拡大していき、機能も拡充していく予定です。よりよいサービスを提供できるように進めていきますので、何でも結構です、フィードバックやコメントなどお待ちしております。
        </p>
      </v-col>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          会社概要
        </h1>
        <p class="font-weight-bold textBlack--text mb-0">
          社名
        </p>
        <p class="indent mb-0">
          株式会社Attic Start   (英語表記：Attic Start Inc.)
        </p>
        <p class="indent mb-4">
          社名の由来については<a href="https://paikeout.com/blog/ja/?p=603" target="_blank">コチラ</a>
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          設立
        </p>
        <p class="indent mb-4">
          2019年6月27日
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          代表
        </p>
        <p class="indent mb-4">
          代表取締役CEO 冨田 啓輔
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          本社
        </p>
        <p class="indent mb-4">
          東京都千代田区平河町2-5-3 Nagatacho GRID 5F
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          拠点
        </p>
        <p class="indent mb-4">
          福岡県福岡市中央区大名2-6-11 fgn.
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          連絡先
        </p>
        <p class="indent mb-4">
          <a href="mailto:support@paikeout.com">support@paikeout.com</a>
        </p>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
  }),
};
</script>

<style lang="stylus" scoped>
.indent
  text-indent 1em

p
  line-height 1.5
  font-size 15px

p.caption
   font-size 0.8rem

.sp
  p, ul, ol
    font-size 12px
</style>